import { createStore } from "vuex";

const store = createStore({
  state: {
    token: null,
    user: null,

    estates: [],
    apartments: [],
    clients: [],
    payments: [],
    clientpayment: [],
    clientPayments: [],
    MpesaPayments: [],
    requesting_clients: [],
    messages: [],
    voters: [],
    numbers: ["073322", "099883"],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    removeToken(state) {
      state.token = null;
    },
    removeUser(state) {
      state.user = null;
    },
    setEstates(state, estates) {
      state.estates = estates;
    },
      
    setApartments(state, apartments) {
      state.apartments = apartments;
    },
    setClients(state, clients) {
      state.clients = clients;
    },
    setPayments(state, payments) {
      state.payments = payments;
    },
   

    setRevenues(state, revenues) {
      state.revenues = revenues;
    },
    setMpesapayments(state, MpesaPayments) {
      state.MpesaPayments = MpesaPayments;
    },
    setRequestingClients(state, requesting_clients) {
      state.requesting_clients = requesting_clients;
    },
    setMessages(state, messages) {
      state.messages = messages;
    },
    setNumber(state, numbers) {
      state.numbers = numbers;
    },
    setVoters(state, voters) {
      state.voters = voters;
    },
  },
  actions: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

     async LoadEstates(context) {
      const url = `https://api.roberms.com/gla/get/estates`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const estates = [];
      for (const key in responseData) {
        const estate = {
          id: key,
          estateId: responseData[key].id,
          estateName: responseData[key].estateName,
          area: responseData[key].area,
          reg_date: responseData[key].createdAt,
        };
        estates.push(estate);
      }
      context.commit("setEstates", estates);
    },
     async LoadApartments(context) {
      const url = `https://api.roberms.com/gla/get/apartments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const apartments = [];
      for (const key in responseData) {
        const apartment = {
          id: key,
          apartment_id: responseData[key].id,
          apartment_name: responseData[key].apartment_name,
          area: responseData[key].area,
          reg_date: responseData[key].createdAt,
        };
        apartments.push(apartment);
      }
      context.commit("setApartments", apartments);
    },


    async LoadMessages(context) {
      const url = `https://api.roberms.com/gla/get/messages`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const messages = [];
      for (const key in responseData) {
        const message = {
          id: key,
          dest_msisdn: responseData[key].dest_msisdn,
          message: responseData[key].message,
          sent_date: responseData[key].sent_date,
        };
        messages.push(message);
      }
      context.commit("setMessages", messages);
    },
    async LoadClients(context) {
      const url = `https://api.roberms.com/gla/get/clients`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const clients = [];
      for (const key in responseData) {
        const client = {
          id: key,
          client_id: responseData[key].id,
          name: responseData[key].client_name,
          phone: responseData[key].phone,
          estate: responseData[key].estate.estateName,
          estateId: responseData[key].estateId,
          house_number: responseData[key].house_number,
          apartment: responseData[key].apartment,

          arrears: responseData[key].arrears,
                    client_type: responseData[key].client_type,

          
          isActive: responseData[key].isActive,
          montlyPayment: responseData[key].monthly_payment,
          reg_date: responseData[key].createdAt,
        };
        clients.push(client);
      }
      context.commit("setClients", clients);
    },
    async LoadWebClients(context) {
      const url = `https://api.roberms.com/gla/get/new/client`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const requesting_clients = [];
      for (const key in responseData) {
        const client = {
          id: key,
          client_id: responseData[key].id,
          name: responseData[key].client_name,
          phone: responseData[key].phone,
          estate: responseData[key].estate.estateName,

          approved: responseData[key].Approved,
          reg_date: responseData[key].reg_date,
        };
        requesting_clients.push(client);
      }
      context.commit("setRequestingClients", requesting_clients);
    },

    async loadVoters(context) {
      const url = `https://api.roberms.com/nyamoko/ekerenyo/voters`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const voters = [];
      for (const key in responseData) {
        const voter = {
          id: key,
          id_number: responseData[key].id_number,
          Dateofbirth: responseData[key].Dateofbirth,
          full_names: responseData[key].full_names,

          polling_center: responseData[key].polling_center,
          sex: responseData[key].sex,
        };
        voters.push(voter);
      }
      context.commit("setVoters", voters);
    },

    async LoadPayments(context) {
      const url = `https://api.roberms.com/gla/get/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const payments = [];

      for (const key in responseData) {
        const payment = {
          id: key,
          clientId: responseData[key].clientId,
          payment_type: responseData[key].payment_type,
          amount: responseData[key].amount,
          reference: responseData[key].payment_reference,

          paid_by: responseData[key].paid_by,
          payment_date: responseData[key].payment_date,
          phone: responseData[key].phone,
          payment_reference: responseData[key].payment_reference,
          processed: responseData[key].processed,
        };
        payments.push(payment);
      }
      context.commit("setPayments", payments);
    },
    async LoadNumbers(context) {
      const url = `https://api.roberms.com/gla/get/numbers`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const numbers = [];

      for (const key in responseData) {
        const number = {
          id: key,
          phone: responseData[key].phone,
        };
        numbers.push(number);
      }
      context.commit("setNumbers", numbers);
    },
    async LoadMpesapayments(context) {
      const url = `https://api.roberms.com/gla/get/mpesa`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const MpesaPayments = [];

      for (const key in responseData) {
        const payment = {
          id: key,

          paid_by: responseData[key].paid_by,
          phone: responseData[key].phone_number,
          amount: responseData[key].amount,
          payment_date: responseData[key].payment_date,
          account_number: responseData[key].clientId,

          
          reference: responseData[key].payment_reference,
          processed: responseData[key].processed,
        };
        MpesaPayments.push(payment);
      }
      context.commit("setMpesapayments", MpesaPayments);
    },
  },
  getters: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

    clients: (state) => state.clients,
    voters: (state) => state.voters,
    phone_numbers: (state) => state.numbers,
    revenues: (state) => state.revenues,
    estates: (state) => state.estates,
        apartments: (state) => state.apartments,

    payments: (state) => state.payments,
    ClientPayments: (state) => state.clientPayments,

    PaymentGetter: (state) => (client) =>
      state.payments.filter((pay) => pay.client_id == client),
    clientName: (state) => (client) =>
      state.clients.filter((pay) => pay.client_id == client),
    estateName: (state) => (estate) =>
      state.estates.filter((name) => name.estateId == estate),
    estatePaymentGetter: (state) => (estate) =>
      state.payments.filter((pay) => pay.estate_id == estate),
    estateClientsGetter: (state) => (estate) =>
      state.clients.filter((pay) => pay.estateId == estate),
    MpesaPayments: (state) => state.MpesaPayments||[],
    RequestingClients: (state) => state.requesting_clients,
    messagesGetter: (state) => state.messages,
    unAllocatedMpesaPayments: (state) => () =>
      state.MpesaPayments.filter((pay) => pay.processed == 0),

    // clientName: (state) => (client)=> state.clients.filter(pay=pay.client_id=client)
  },

  //
});
export default store;
